export default {
    userId: {
        formProp: 'userId',
        form: {
            label: 'User ID',
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'User ID...'
        },
        validation: [ 'min-length:3', 'alphanumeric' ]
    },
    email: {
        formProp: 'email',
        form: {
            label: 'Email Address',
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'Email...'
        },
        validation: [ 'email' ]
    },
    verifyEmail: {
        formProp: 'verifyEmail',
        form: {
            label: 'Verify Email Address',
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'Email...'
        },
        validation: [ 'email' ]
    }
}
